<div class="card">
  <div class="card-header d-flex align-items-center justify-content-between">
    <h4 class="mb-0">Packers & Movers Details</h4>
    <button class="btn btn-primary btn-sm mr-3" (click)="goBack()">
      <i class="fa fa-arrow-left"></i> Back
    </button>
  </div>

  <div class="card-body">
    <div class="row">
      <div class="col-md-4 mb-3">
        <strong>PM ID</strong>
        <p>{{ packersMoversDetails?.pmId }}</p>
      </div>

      <div class="col-md-4 mb-3">
        <strong>Request Type</strong>
        <p>{{ packersMoversDetails?.requestType }}</p>
      </div>

      <div class="col-md-4 mb-3">
        <strong>Status</strong>
        <p>{{ packersMoversDetails?.status }}</p>
      </div>

      <div class="col-md-4 mb-3">
        <strong>Name</strong>
        <p>{{ packersMoversDetails?.name }}</p>
      </div>

      <div class="col-md-4 mb-3">
        <strong>Email</strong>
        <p>{{ packersMoversDetails?.email }}</p>
      </div>

      <div class="col-md-4 mb-3">
        <strong>Mobile</strong>
        <p>{{ packersMoversDetails?.mobile }}</p>
      </div>

      <div class="col-md-4 mb-3">
        <strong>Property Type</strong>
        <p>{{ packersMoversDetails?.propertyType }}</p>
      </div>

      <div class="col-md-4 mb-3">
        <strong>Property Sub Type</strong>
        <p>{{ packersMoversDetails?.propertySubType }}</p>
      </div>

      <div class="col-md-4 mb-3">
        <strong>Moving Date</strong>
        <p>{{ packersMoversDetails?.movingDate }}</p>
      </div>

      <div class="col-md-6 mb-3">
        <strong>Pickup Location</strong>
        <p>{{ packersMoversDetails?.pickupLocation }}</p>
      </div>

      <div class="col-md-6 mb-3">
        <strong>Drop Location</strong>
        <p>{{ packersMoversDetails?.dropLocation }}</p>
      </div>
    </div>

    <hr />

    <h5>Pickup Details</h5>

    <div class="row">
      <div class="col-md-6">
        <strong>Address</strong>
        <p>{{ packersMoversDetails?.pickDetails?.address }}</p>
      </div>

      <div class="col-md-3">
        <strong>Floor No</strong>
        <p>{{ packersMoversDetails?.pickDetails?.floorNo }}</p>
      </div>

     <div class="col-md-3">
        <strong>Service Lift</strong>
        <p>
          {{ packersMoversDetails?.pickDetails?.serviceLift ? "Yes" : "No" }}
        </p>
      </div>

      <div class="col-md-6">
        <strong>Parking Distance</strong>
        <p>{{ packersMoversDetails?.pickDetails?.parkingDistance }}</p>
      </div>

      <div class="col-md-6">
        <strong>Time</strong>
        <p>{{ packersMoversDetails?.pickDetails?.time }}</p>
      </div>
    </div>

    <hr />

    <h5>Drop Details</h5>

    <div class="row">
      <div class="col-md-6">
        <strong>Address</strong>
        <p>{{ packersMoversDetails?.dropDetails?.address }}</p>
      </div>

      <div class="col-md-3">
        <strong>Floor No</strong>
        <p>{{ packersMoversDetails?.dropDetails?.floorNo }}</p>
      </div>

      <div class="col-md-3">
        <strong>Service Lift</strong>
        <p>
          {{ packersMoversDetails?.dropDetails?.serviceLift ? "Yes" : "No" }}
        </p>
      </div>

        <div class="col-md-6">
          <strong>Parking Distance</strong>
          <p>{{ packersMoversDetails?.dropDetails?.parkingDistance }}</p>
        </div>

        <div class="col-md-6">
          <strong>Time</strong>
          <p>{{ packersMoversDetails?.dropDetails?.time }}</p>
        </div>
      </div>

      <hr />

      <h5>Payment Details</h5>

      <div class="row">
        <div class="col-md-3">
          <strong>Amount</strong>
          <p>₹ {{ packersMoversDetails?.paymentDetails?.amount }}</p>
        </div>

        <div class="col-md-3">
          <strong>Method</strong>
          <p>{{ packersMoversDetails?.paymentDetails?.paymentMethod }}</p>
        </div>

        <div class="col-md-3">
          <strong>Status</strong>

          <p *ngIf="packersMoversDetails?.paymentDetails?.status == 0">
            Pending
          </p>

          <p *ngIf="packersMoversDetails?.paymentDetails?.status == 1">Paid</p>

          <p *ngIf="packersMoversDetails?.paymentDetails?.status == 2">
            Partial
          </p>

          <p *ngIf="packersMoversDetails?.paymentDetails?.status == 3">
            Failed
          </p>
        </div>

        <div class="col-md-3">
          <strong>Transaction Id</strong>
          <p>
            {{ packersMoversDetails?.paymentDetails?.transactionId || "-" }}
          </p>
        </div>
      </div>

      <hr />

      <div *ngIf="packersMoversDetails?.requestType === 'VIDEO'">
        <h5>Uploaded Videos</h5>
        <div class="row">
          <div
            class="col-lg-6 col-md-6 col-sm-12 mb-4"
            *ngFor="let video of packersMoversDetails?.videos"
          >
            <iframe
              width="100%"
              height="250"
              [src]="getYoutubeEmbedUrl(video)"
              frameborder="0"
              allowfullscreen
            >
            </iframe>
          </div>
        </div>
      </div>

      <div *ngIf="packersMoversDetails?.requestType === 'FORM'">
        <h5>Inventory Summary</h5>

        <div class="row">
          <div class="col-md-4">
            <strong>Total Items</strong>
            <p>{{ packersMoversDetails?.totalItems }}</p>
          </div>
        </div>

        <div *ngIf="packersMoversDetails?.requestType === 'FORM'">
          <h5 class="mb-3">Furniture Items</h5>

          <table
            class="table table-bordered"
            *ngIf="getFurnitureItems().length"
          >
            <thead>
              <tr>
                <th>Category</th>
                <th>Item</th>
                <th>Qty</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of getFurnitureItems()">
                <td>{{ item.category }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.qty }}</td>
              </tr>
            </tbody>
          </table>

          <h5 class="mt-4 mb-3">Appliances Items</h5>

          <table
            class="table table-bordered"
            *ngIf="getAppliancesItems().length"
          >
            <thead>
              <tr>
                <th>Category</th>
                <th>Item</th>
                <th>Qty</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of getAppliancesItems()">
                <td>{{ item.category }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.qty }}</td>
              </tr>
            </tbody>
          </table>

          <h5 class="mt-4 mb-3">Cartons & Bags</h5>

          <table class="table table-bordered" *ngIf="getCartonsItems().length">
            <thead>
              <tr>
                <th>Category</th>
                <th>Item</th>
                <th>Qty</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of getCartonsItems()">
                <td>{{ item.category }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.qty }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

